import { render, staticRenderFns } from "./DropdownLevel.vue?vue&type=template&id=0c3157e3&scoped=true"
import script from "./DropdownLevel.vue?vue&type=script&lang=js"
export * from "./DropdownLevel.vue?vue&type=script&lang=js"
import style0 from "./DropdownLevel.vue?vue&type=style&index=0&id=0c3157e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3157e3",
  null
  
)

export default component.exports